var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Link Recipient",
        visible: _vm.visible,
        width: "80%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: { inline: "" },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.handleSearch.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "info", icon: "el-icon-link" },
                  on: { click: _vm.handleLink }
                },
                [_vm._v("\n\t\t\t\tLink\n\t\t\t")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { size: "mini", placeholder: "Search Recipient" },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "prefix" },
                    slot: "prefix"
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.handleSearch }
                },
                [_vm._v("\n\t\t\t\tSearch\n\t\t\t")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.recipients,
            "default-sort": { prop: "name", order: "ascending" }
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t("name"), width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v("\n\t\t\t\t" + _vm._s(scope.row.name) + "\n\t\t\t")
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$tc("legalEntity"),
              prop: "legal_entity_by_reference.registration_name",
              "show-overflow-tooltip": "",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          scope.row.legal_entity_by_reference &&
                            scope.row.legal_entity_by_reference
                              .registration_name
                            ? scope.row.legal_entity_by_reference
                                .registration_name
                            : ""
                        ) +
                        "\n\t\t\t"
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t("accountId"), width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(scope.row.account_id) + "\n\t\t\t"
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.channel_endpoints, function(
                    endpoint,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          "margin-bottom": "4px",
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "blueColor",
                          class: {
                            "el-icon-postcard": endpoint.channel === "MAIL",
                            "el-icon-phone": endpoint.channel === "PHONE",
                            "el-icon-message": endpoint.channel === "EMAIL",
                            "el-icon-edit": !(
                              endpoint.channel === "MAIL" ||
                              endpoint.channel === "PHONE" ||
                              endpoint.channel === "EMAIL"
                            )
                          },
                          staticStyle: {
                            "margin-right": "6px",
                            "font-size": "12px"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(endpoint.endpoint))])
                      ]
                    )
                  })
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }